module.exports = __webpack_public_path__ + "img/1536068585.6bf5dcaa.jpg";